const Index = () => import(/* webpackChunkName: "chat-index" */ './index.vue');
const List = () => import(/* webpackChunkName: "chat-list" */ './components/List.vue');
const Conversation = () => import(/* webpackChunkName: "chat-conversation" */ './components/Conversation.vue');

export default [
  {
    path: 'chat',
    name: 'chat',
    component: Index,
    redirect: { name: 'chat-list' },
    children: [
      {
        path: '',
        name: 'chat-list',
        component: List,
      },
      {
        path: ':conversationId',
        name: 'chat-conversation',
        component: Conversation,
        props: true,
      },
    ],
  },
];